import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query VimeoVideoPicturesInfo ($id: ID!, $videoID: ID!, $limit: Int, $offset: Int) {
      VimeoVideoPicturesInfo (id: $id, videoID: $videoID, limit: $limit, offset: $offset) {
        limit
        offset
        totalItems
        pictures {
          ...vimeoPictureDetail
        }
      }
    }
    ${fragments.vimeoPictureDetail}
  `
